var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
import { SlaBoundaries } from '../../enums/workload/sla-boundaries';
var NotSet = SlaBoundaries.NotSet;
var SlaBoundariesPipe = /** @class */ (function () {
    function SlaBoundariesPipe() {
    }
    SlaBoundariesPipe.prototype.transform = function (sla) {
        switch (sla) {
            case NotSet:
                return 'Not Set';
            case SlaBoundaries.TwoDays:
                return '2 Days';
            case SlaBoundaries.FiveDays:
                return '5 Days';
            case SlaBoundaries.TenDays:
                return '10 Days';
            case SlaBoundaries.TwentyFiveDays:
                return '25 Days';
            case SlaBoundaries.ThirtyDays:
                return '30 Days';
            case SlaBoundaries.ThirtyFiveDays:
                return '35 Days';
            default:
                return 'Invalid Value';
        }
    };
    SlaBoundariesPipe = __decorate([
        Pipe({ name: 'slaBoundaries' })
    ], SlaBoundariesPipe);
    return SlaBoundariesPipe;
}());
export { SlaBoundariesPipe };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2xhLWJvdW5kYXJpZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzbGEtYm91bmRhcmllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxPQUFPLEVBQUUsSUFBSSxFQUFpQixNQUFNLGVBQWUsQ0FBQztBQUVwRCxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0scUNBQXFDLENBQUM7QUFDcEUsSUFBTyxNQUFNLEdBQUcsYUFBYSxDQUFDLE1BQU0sQ0FBQztBQUdyQztJQUFBO0lBcUJBLENBQUM7SUFwQlUscUNBQVMsR0FBaEIsVUFBaUIsR0FBa0I7UUFDL0IsUUFBUSxHQUFHLEVBQUU7WUFDVCxLQUFLLE1BQU07Z0JBQ1AsT0FBTyxTQUFTLENBQUM7WUFDckIsS0FBSyxhQUFhLENBQUMsT0FBTztnQkFDdEIsT0FBTyxRQUFRLENBQUM7WUFDcEIsS0FBSyxhQUFhLENBQUMsUUFBUTtnQkFDdkIsT0FBTyxRQUFRLENBQUM7WUFDcEIsS0FBSyxhQUFhLENBQUMsT0FBTztnQkFDdEIsT0FBTyxTQUFTLENBQUM7WUFDckIsS0FBSyxhQUFhLENBQUMsY0FBYztnQkFDN0IsT0FBTyxTQUFTLENBQUM7WUFDckIsS0FBSyxhQUFhLENBQUMsVUFBVTtnQkFDekIsT0FBTyxTQUFTLENBQUM7WUFDckIsS0FBSyxhQUFhLENBQUMsY0FBYztnQkFDN0IsT0FBTyxTQUFTLENBQUM7WUFDckI7Z0JBQ0ksT0FBTyxlQUFlLENBQUM7U0FDOUI7SUFDTCxDQUFDO0lBcEJRLGlCQUFpQjtRQUQ3QixJQUFJLENBQUMsRUFBRSxJQUFJLEVBQUUsZUFBZSxFQUFFLENBQUM7T0FDbkIsaUJBQWlCLENBcUI3QjtJQUFELHdCQUFDO0NBQUEsQUFyQkQsSUFxQkM7U0FyQlksaUJBQWlCIn0=